
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/developers/display-advertising",
      function () {
        return require("private-next-pages/products/developers/display-advertising.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/developers/display-advertising"])
      });
    }
  